import Checkboxes from 'components/Form/Checkboxes';
import Dropdown from 'components/Form/Dropdown';
import Field from 'components/Form/Field';
import FileUpload from 'components/Form/FileUpload';
import {maxFileSize} from 'components/Form/FileUpload/utils';
import FormActions from 'components/Form/FormActions';
import FormResult from 'components/Form/FormResult';
import InputText from 'components/Form/InputText';
import SubmitButton from 'components/Form/SubmitButton';
import SideBySide from 'components/Layout/SideBySide';
import Link from 'components/Link';
import {useFormContext} from 'react-hook-form';
import {useBackend} from 'state/backend';
import {jt, t} from 'ttag';
import {documentTypeLabelByType} from 'utils/document-type';

import {CustomTemplateCreateBackendData} from '../../types';

const links = {
    helpCenter:
        'https://help.makeleaps.jp/ja/articles/6376029-ユーザー定義テンプレート-テンプレートを追加する?segment_aid=d9a4b263-2d98-4bc1-bd24-63b0b1ea986b',
};

const CustomTemplateForm = () => {
    const {data} = useBackend<CustomTemplateCreateBackendData>();

    const methods = useFormContext();

    const isSubmitButtonDisabled = !methods.formState.isDirty;

    const br = <br />;

    const helpCenter = (
        <Link href={links.helpCenter} key="help-center">
            {t`Help Center`}
        </Link>
    );
    const documentTypeLabel = documentTypeLabelByType(data.documentType);

    return (
        <SideBySide className="mt-4" classNameLabel="w-[18rem] max-w-[18rem]">
            <InputText
                label={t`Display name`}
                name="displayName"
                required={true}
            />
            <Field label={t`Document Type`} type="value">
                {documentTypeLabel}
            </Field>
            <Dropdown
                label={t`Template Language`}
                name="baseTemplateCode"
                options={data.templateLanguages}
                required={true}
                type="select"
            />
            <Checkboxes
                label={jt`Use advanced Tax Types ${br} (not legacy Types)`}
                options={[
                    {
                        name: 'useAdvancedTaxSettings',
                        required: false,
                    },
                ]}
            />
            <InputText
                helpText={
                    <div>{jt`Optional. When set, replaces the standard Document Type Name ("${documentTypeLabel}") used in client-facing emails etc. See the ${helpCenter}(Japanese site).`}</div>
                }
                label={t`Custom Document Title`}
                name="documentTitle"
                required={false}
            />
            <FileUpload
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                helpText={t`The file size must be smaller than 10MB.`}
                label={t`Upload a File`}
                name="uploadedFile"
                validate={maxFileSize('10MB')}
            />
            <FormResult />
            <FormActions align="left">
                <SubmitButton
                    disabled={isSubmitButtonDisabled}
                >{t`Save`}</SubmitButton>
            </FormActions>
        </SideBySide>
    );
};

export default CustomTemplateForm;
